import AddEditGameModal from "./AddEditGameModal";

export default AddEditGameModal;